/**
 * The registration step's standard look: the form page, with the app's consent
 * row above the button (PrivacyConsentRowView; its policy link opens a new tab,
 * row R1), or the app's words for a form that could not be read. Draws the
 * behavior half's state and calls its actions; holds no rule.
 */
import { PrivacyConsentRowView } from '@/components/forms/PrivacyConsentRowView';
import { formFailure } from '@/pages/DetailsPage/FormStepScreen';

import { partsOf } from '../../contract/runtime';
import { FormSheet, FormSheetFailure } from '../../ui/FormSheet';
import type { RegistrationStepRuntime } from './useRegistrationStep';
import { contract } from './contract';

const part = partsOf(contract);

/** The privacy agreement row, the app's own, with the piece's parts; shared with the phone registration. */
export function ConsentRow({ state, actions }: Pick<RegistrationStepRuntime, 'state' | 'actions'>) {
  return (
    <PrivacyConsentRowView
      checked={state.consented}
      onChange={actions.setConsent}
      showError={state.consentError}
      errorId="web-privacy-consent-error"
      parts={{ row: part('consent'), link: part('policyLink'), error: part('consentError') }}
    />
  );
}

export function RegistrationStepView({ state, actions, page, submit }: RegistrationStepRuntime) {
  const failure = formFailure({ isError: page.formsError != null, errorMessage: page.formsError }, page.formFailed, actions.back);
  if (failure?.kind === 'error') return <FormSheetFailure failure={failure} piece={contract} />;
  if (!page.form) return null;
  const consentRow = page.form.privacyConsentRequired ? <ConsentRow state={state} actions={actions} /> : null;

  return (
    <FormSheet
      piece={contract}
      form={page.form}
      index={page.index}
      total={page.total}
      paymentAhead={page.paymentAhead}
      submitting={page.submitting}
      fieldErrors={page.fieldErrors}
      submitError={page.submitError}
      backLabel={page.backLabel}
      onBack={actions.back}
      backDisabled={page.backPending}
      onSubmit={submit}
      onSave={page.save}
      beforeButton={consentRow}
    />
  );
}
